import Gobalstore from "../index";
export const actions = {
  getOrg: function (localStore) {
    return new Promise((resolve, reject) => {
      Gobalstore.commit("LoadingOverlay", true);
      this.axios({
        method: "GET",
        url: `/admin/guarded/management/organization/`,
      })
        .then(function (response) {
          localStore.commit("setOrg", response.data);
          Gobalstore.commit("LoadingOverlay", false);
          resolve(response);
        })
        .catch((err) => {
          Gobalstore.commit("LoadingOverlay", false);
          reject(err);
        });
    });
  },
};
